export const httpStatusCodes = Object.freeze({
  forbidden_403: 403,
  not_found_404: 404,
});
